import { useErrors } from '@auth0/auth0-acul-react/signup-id';
import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthErrorBanner } from '@/components/AuthErrorBanner/AuthErrorBanner';
import { Text } from '@/components/Typography/Text/Text';
import { useTrackErrors } from '@/hooks/useTrackErrors';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackPageView } from '@/lib/tagging';
import { EmailSignupForm } from '@/screens/signup-id/components/EmailSignupForm';

function SignupIdScreen() {
  const { t } = useTranslation('signupId');
  useTransactionLocale();

  const { errors } = useErrors();
  const { generalErrorMessages, fieldErrors } = useTrackErrors(
    errors,
    'selfactivation/error',
  );

  useEffect(() => {
    trackPageView('selfactivation/email');
  }, []);

  return (
    <BaseWrapper title={t('header')}>
      <Text align="center" className="u-margin-b-l">
        {t('info')}
      </Text>
      <AuthErrorBanner errors={generalErrorMessages} />
      <EmailSignupForm fieldErrors={fieldErrors} />
    </BaseWrapper>
  );
}

export default SignupIdScreen;
